import type { IMaybeAsync } from '~/helpers/types';
import { STORAGE_KEY_PREFIX } from '../constants';

export type IStorageOptions = {
  prefix?: string;
  namespace?: string;
};

export type IStorageAttributes = {
  daysUntilExpire?: number;
  cookieDomain?: string;
};

export const defaultOptions = {
  prefix: STORAGE_KEY_PREFIX,
};

/**
 * Defines a type that handles storage to/from a storage location.
 */
export type IStorage = {
  set<T>(
    key: string,
    value: T,
    options?: IStorageAttributes,
  ): IMaybeAsync<void>;
  get<T>(key: string): T | undefined;
  delete(key: string, options?: IStorageAttributes): void;
  clear?(): void;
  allKeys?(): Array<string>;
};
